// Member badge palette - the single source of truth for the colours a family
// member can choose to identify themselves. Each phone stores one badge key
// (e.g. "teal") in localStorage; the colour is looked up here so list rows
// and the setup modal all render identical badges.
//
// `bg` is the badge fill, `text` is the initial colour on top of it. Colours
// are picked for good contrast against both the apricot light theme and dark
// mode, and to be distinguishable from each other (including for most common
// colour-vision deficiencies - we pair colour with the member's initial so a
// badge is never colour-only).

export const MEMBER_BADGES = [
  { key: "teal",    label: "Teal",    bg: "#0D9488", text: "#FFFFFF" },
  { key: "blue",    label: "Blue",    bg: "#2563EB", text: "#FFFFFF" },
  { key: "indigo",  label: "Indigo",  bg: "#4F46E5", text: "#FFFFFF" },
  { key: "purple",  label: "Purple",  bg: "#7C3AED", text: "#FFFFFF" },
  { key: "magenta", label: "Magenta", bg: "#C026D3", text: "#FFFFFF" },
  { key: "pink",    label: "Pink",    bg: "#DB2777", text: "#FFFFFF" },
  { key: "rose",    label: "Rose",    bg: "#E11D48", text: "#FFFFFF" },
  { key: "red",     label: "Red",     bg: "#DC2626", text: "#FFFFFF" },
  { key: "orange",  label: "Orange",  bg: "#EA580C", text: "#FFFFFF" },
  { key: "amber",   label: "Amber",   bg: "#D97706", text: "#FFFFFF" },
  { key: "lime",    label: "Lime",    bg: "#65A30D", text: "#FFFFFF" },
  { key: "green",   label: "Green",   bg: "#16A34A", text: "#FFFFFF" },
  { key: "emerald", label: "Emerald", bg: "#059669", text: "#FFFFFF" },
  { key: "cyan",    label: "Cyan",    bg: "#0891B2", text: "#FFFFFF" },
  { key: "slate",   label: "Slate",   bg: "#475569", text: "#FFFFFF" },
  { key: "brown",   label: "Brown",   bg: "#92400E", text: "#FFFFFF" },
];

export const DEFAULT_BADGE_KEY = "teal";

// Look up a badge by key. Falls back to the default so a missing/old key never
// renders a broken badge.
export function getBadge(key) {
  return MEMBER_BADGES.find((b) => b.key === key) || MEMBER_BADGES.find((b) => b.key === DEFAULT_BADGE_KEY);
}

// First letter of a member name, uppercased, for the badge face.
// Returns "" for empty/missing names so callers can decide what to show.
// Up to two letters for the badge face. Two words → their initials (e.g.
// "Mary Jane" → "MJ"); one word → its first two letters (e.g. "Ivan" → "IV").
// Returns "" for empty/missing names so callers can decide what to show.
export function initialOf(name) {
  if (!name || typeof name !== "string") return "";
  const trimmed = name.trim();
  if (!trimmed) return "";
  const words = trimmed.split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
}
